import { Col, Descriptions, Flex, Row } from 'antd';
import { normalizeBankAccount, normalizeCpfCnpj } from 'helpers/normalizers';
import { Account } from 'types/Account';
import { PageWrapper } from 'components/PageWrapper';
import { ETenantType } from 'types/Company';
import { StarIcon } from 'components/Icons/Star';
import {
	DescriptionItem,
	DescriptionsWrapper,
} from './EscrowAccountInfoHeader.styles';

export interface IEscrowAccountInfoHeaderProps {
	account: Account;
}

const EscrowAccountInfoHeader = ({
	account,
}: IEscrowAccountInfoHeaderProps) => {
	const descriptionItems = [
		{
			key: '1',
			label: 'Titular',
			children: <DescriptionItem>{account.person.name}</DescriptionItem>,
		},
		{
			key: '2',
			label: 'Documento',
			children: (
				<DescriptionItem>
					{normalizeCpfCnpj(account.person.taxpayer_id)}
				</DescriptionItem>
			),
		},
		{
			key: '3',
			label: 'Instituição',
			children: (
				<DescriptionItem>
					509 - Celcoin Instituição de Pagamento S.A
				</DescriptionItem>
			),
		},
		{
			key: '4',
			label: 'Agência',
			children: (
				<DescriptionItem>{account.branch ?? '-'}</DescriptionItem>
			),
		},
		{
			key: '5',
			label: 'Conta',
			children: (
				<Flex align="center">
					{account.tenant_type !== ETenantType.DEFAULT && (
						<StarIcon size={16} />
					)}
					<DescriptionItem>
						{account.account
							? normalizeBankAccount(account.account)
							: '-'}
					</DescriptionItem>
				</Flex>
			),
		},
	];

	return (
		<PageWrapper>
			<Row gutter={[16, 16]} style={{ margin: '1rem 0' }}>
				<Col>
					<DescriptionsWrapper>
						<Descriptions
							layout="vertical"
							column={5}
							items={descriptionItems}
							contentStyle={{
								margin: '0 0.5rem 0 0',
							}}
						/>
					</DescriptionsWrapper>
				</Col>
			</Row>
		</PageWrapper>
	);
};

export default EscrowAccountInfoHeader;
